exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bonus-table-loader {\n\theight: 30px;\n\twidth: 30px;\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n}\n\n.bonus-table-loader > img {\n\tmargin-top: 0;\n}\n", ""]);

